import React from 'react';
import clsx from 'clsx';
import { Modal } from 'tt-ui-lib/core';
import ModalContainer from '../ModalContainer';
import CheckboxWithButton from './CheckboxWithButton';

import styles from './ConsentModal.module.scss';

const ConsentModal = ({
  isModelOpen,
  setIsOpen,
  handleClose,
  setIsAgree,
  isAgree,
  checkboxText,
  isShouldScroll,
  isScrolled,
  children,
  background,
  isFullScreenActive,
  setIsFullScreenActive,
  isFullScreen,
}) => (
  <Modal
    open={isModelOpen}
    onClose={() => handleClose(setIsOpen)}
    className={isFullScreenActive ? styles.backDrop : styles.modal}
    wrapClassName={isFullScreenActive ? styles.fullScreenActiveModalWrapper : styles.modalWrapper}
    width={isFullScreenActive ? 1400 : 1000}
    closable={false}
    maskClosable={false}
    centered
    destroyOnClose
  >
    <ModalContainer
      background={background || 'rgba(255, 255, 255, 0.8)'}
      isShouldScroll={isShouldScroll}
      handleClose={() => handleClose(setIsOpen)}
      isConsentModal
      isFullScreen={isFullScreen}
      isFullScreenActive={isFullScreenActive}
      setIsFullScreenActive={setIsFullScreenActive}
    >
      <div
        className={clsx(
          styles.consentWrapper,
          isFullScreenActive ? styles.fullScreenContentWrapper : ''
        )}
      >
        {children}
        <CheckboxWithButton
          isAgree={isAgree}
          setIsAgree={setIsAgree}
          text={checkboxText}
          handleClose={handleClose}
          setIsOpen={setIsOpen}
          isShouldScroll={isShouldScroll}
          isScrolled={isScrolled}
        />
      </div>
    </ModalContainer>
  </Modal>
);

export default ConsentModal;
